import {AllShortcutsEnabled} from '@github-ui/code-view-shared/components/AllShortcutsEnabled'
import {useFilesPageInfo, useReposAppPayload} from '@github-ui/code-view-shared/contexts/FilesPageInfoContext'
import {useReposAnalytics} from '@github-ui/code-view-shared/hooks/use-repos-analytics'
import {useUrlCreator} from '@github-ui/code-view-shared/hooks/use-url-creator'
import {Link} from '@github-ui/react-core/link'
import {ActionList, Box} from '@primer/react'

import {useCurrentBlob} from '../../../hooks/CurrentBlob'
import OpenWithActionItems from './OpenWithActionItems'

export default function EditMenuActionItems({
  editAllowed,
  hasOpenWithItem,
}: {
  editAllowed: boolean
  hasOpenWithItem: boolean
}) {
  const payload = useCurrentBlob()
  const {
    refInfo: {canEdit},
  } = useFilesPageInfo()
  const {githubDevUrl} = useReposAppPayload()
  const {sendRepoClickEvent} = useReposAnalytics()
  const {getUrl} = useUrlCreator()

  const {
    headerInfo: {ghDesktopPath, onBranch},
  } = payload

  return (
    <>
      {editAllowed && (
        <ActionList.Group>
          <ActionList.GroupHeading>Edit file</ActionList.GroupHeading>
          <ActionList.Item
            as={Link}
            onSelect={() => sendRepoClickEvent('BLOB_EDIT_DROPDOWN.IN_PLACE')}
            to={getUrl({action: 'edit'})}
            aria-keyshortcuts="e"
          >
            <Box sx={{display: 'flex'}}>Edit in place</Box>
            <ActionList.TrailingVisual aria-hidden="true">
              <AllShortcutsEnabled>
                <kbd>e</kbd>
              </AllShortcutsEnabled>
            </ActionList.TrailingVisual>
          </ActionList.Item>
        </ActionList.Group>
      )}
      {editAllowed && hasOpenWithItem && <ActionList.Divider />}
      {hasOpenWithItem && (
        <OpenWithActionItems
          editEnabled={canEdit}
          githubDevUrl={githubDevUrl}
          ghDesktopPath={ghDesktopPath}
          onBranch={onBranch}
        />
      )}
    </>
  )
}

try{ EditMenuActionItems.displayName ||= 'EditMenuActionItems' } catch {}